import React, { useState } from "react";
import "../css/SchoolFAQ.css";

const faqData = {
  General: [
    {
      question: "What is the vision of Sahara Public School?",
      answer:
        "Sahara Public School aims to provide quality education that develops academic excellence, strong values, creativity, leadership, and confidence in every student.",
    },
    {
      question: "Which curriculum does Sahara Public School follow?",
      answer:
        "Sahara Public School follows a modern curriculum that combines strong academics with practical learning, innovation, and overall personality development.",
    },
    {
      question:
        "What extracurricular activities are available at Sahara Public School?",
      answer:
        "Students participate in sports, music, dance, art & craft, robotics, coding, debate, cultural events, yoga, and many other co-curricular activities.",
    },
    {
      question: "Does Sahara Public School provide transport facilities?",
      answer:
        "Yes. We provide safe and secure transport facilities with trained drivers and well-maintained school buses covering major routes.",
    },
    {
      question: "What is the fee structure of Sahara Public School?",
      answer:
        "The fee structure depends on the class and academic session. Please contact the admission office for complete details.",
    },
    {
      question: "Why should parents choose Sahara Public School?",
      answer:
        "Our experienced teachers, smart classrooms, excellent infrastructure, discipline, and focus on holistic development make Sahara Public School a preferred choice.",
    },
  ],

  "Book a Meeting": [
    {
      question: "How can I book a meeting with the admission counselor?",
      answer:
        "Parents can book a meeting online through our website or by contacting the school admission office directly.",
    },
    {
      question: "Can I meet the Principal before admission?",
      answer:
        "Yes. Meetings with the Principal can be arranged by prior appointment.",
    },
    {
      question: "Is there any charge for booking a meeting?",
      answer: "No. Admission counselling and meetings are completely free.",
    },
    {
      question: "Can meetings be conducted online?",
      answer:
        "Yes. We provide both online and offline counselling sessions according to your convenience.",
    },
  ],

  "Campus Tour": [
    {
      question: "How can I schedule a campus tour?",
      answer:
        "You can schedule a campus visit by filling out the enquiry form or contacting the school reception.",
    },
    {
      question: "Can parents and students visit together?",
      answer:
        "Yes. Parents are encouraged to visit the campus along with their children.",
    },
    {
      question: "What facilities are included during the tour?",
      answer:
        "The tour includes classrooms, science labs, computer labs, library, sports facilities, activity rooms, and transport facilities.",
    },
    {
      question: "How long does the campus tour take?",
      answer: "The guided campus tour generally takes around 30 to 45 minutes.",
    },
  ],

  Admissions: [
    {
      question: "What is the admission process at Sahara Public School?",
      answer:
        "The admission process includes enquiry, application submission, document verification, interaction or assessment (if applicable), and fee confirmation.",
    },
    {
      question: "Which documents are required for admission?",
      answer:
        "Birth certificate, previous report card, passport-size photographs, Aadhaar card, and transfer certificate (if applicable).",
    },
    {
      question: "Is there an entrance test for admission?",
      answer:
        "Admission assessments may be conducted depending on the class for which admission is sought.",
    },
    {
      question: "When does the admission process begin?",
      answer:
        "Admissions generally begin before the start of the new academic session and continue based on seat availability.",
    },
  ],
};

export default function SchoolFAQ() {
  const tabs = Object.keys(faqData);

  const [activeTab, setActiveTab] = useState("General");
  const [openIndex, setOpenIndex] = useState(null);

  const currentFaqs = faqData[activeTab];

  const handleTab = (tab) => {
    setActiveTab(tab);
    setOpenIndex(null);
  };

  return (
    <section className="school-faq-section">
      <div className="school-faq-left">
        <h2 className="school-faq-heading">Frequently Asked Questions</h2>

        <div className="school-faq-tabs">
          {tabs.map((tab) => (
            <button
              key={tab}
              className={`school-tab ${activeTab === tab ? "active" : ""}`}
              onClick={() => handleTab(tab)}
            >
              {tab}
            </button>
          ))}
        </div>

        <div className="school-faq-list">
          {currentFaqs.map((item, index) => (
            <div className="school-faq-item" key={index}>
              <div
                className="school-faq-question"
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
              >
                <h4>{item.question}</h4>

                <span>{openIndex === index ? "−" : "+"}</span>
              </div>

              <div
                className={`school-faq-answer ${
                  openIndex === index ? "show" : ""
                }`}
              >
                <p>{item.answer}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className="school-faq-right">
        <div className="school-faq-image-wrapper">
          <img
            src="/images/fc.jpeg"
            alt="Sahara Public School"
            className="school-faq-image"
          />

          {}

          <span className="shape-dot shape-dot-1"></span>

          <span className="shape-dot shape-dot-2"></span>

          <span className="shape-square"></span>

          <span className="shape-circle"></span>

          <span className="shape-triangle"></span>

          <span className="shape-plus">+</span>
        </div>
      </div>
    </section>
  );
}
